import { cn } from "@/lib/utils";
import { Trans } from "react-i18next";
import { openLink } from "@telegram-apps/sdk-react";
import { appConfig } from "@/lib/site-config.ts";

interface PrivacyPolicyProps {
  className?: string;
  onClick?: () => void;
}

const PrivacyPolicy = ({ className, onClick }: PrivacyPolicyProps) => {
  const handlePrivacyLinkClick = () => {
    if (openLink.isAvailable() && appConfig.links.privacy) {
      openLink(appConfig.links.privacy, {
        tryInstantView: true,
      });
    }
    onClick?.();
  };

  return (
    <p className={cn("text-xs text-white leading-130 text-center", className)}>
      <Trans
        i18nKey="accept_privacy_terms"
        components={{
          privacy: (
            <span
              onClick={handlePrivacyLinkClick}
              className="text-blue underline cursor-pointer"
            />
          ),
        }}
      />
    </p>
  );
};

export default PrivacyPolicy;
